import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import LocationsBlock from 'desktop/components/LocationsBlock/LocationsBlock';
// import urlMarker from 'shared/assets/images/location-point.svg';
import GroupForm from '../GroupForm/GroupForm';
import s from './SearchFormHeader.css';

class SearchFormHeader extends React.Component {
  static propTypes = {
    isNew: PropTypes.number,
    setAge: PropTypes.func.isRequired,
    isDealerPage: PropTypes.bool,
    age: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
      }),
    ).isRequired,
    withLocation: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    isNew: null,
    isDealerPage: false,
  };

  render() {
    const { isNew, setAge, age, withLocation, isDealerPage } = this.props;
    const currentAge = age.find(item => item.id === isNew);
    return (
      <div className={s.root}>
        <div className={s.left}>
          <GroupForm
            items={age}
            selected={currentAge}
            handleSelect={setAge}
            isDealerPage={isDealerPage}
          />
        </div>
        <div className={s.right}>
          <div className={s.location}>
            {withLocation && <LocationsBlock className={s.locationInput} />}
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(SearchFormHeader);



// WEBPACK FOOTER //
// ./src/desktop/components/SearchPanelV2/SearchFormHeader/SearchFormHeader.js